export default __webpack_public_path__ + "static/media/botPython.59de662b.PNG";